import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '統計で見る！新潟県日本一 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="統計で見る！新潟県日本一" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2022秋号 No.160 目次",
              path: "/no160"
            },
            {
              name: "統計で見る！新潟県日本一"
            }
          ]}
        />
        <img
          src={`${basePath}/no160/img/4-17.png`}
          alt="イラスト"
          css={style.img(250)}
        />
        
        <h4 css={style.subTitle02}>水産練製品の出荷額 352億円</h4>
        <p>かまぼこ、ちくわなど食卓に欠かせない水産練製品。高タンパク質、低脂肪、低カロリーで、ヘルシーフードとして見直されている。最近では、日本食ブームも手伝って欧米でも注目が集まっている。</p>
        <p css={style.notetTxt}>出典：経済産業省「工業統計表 品目別統計表」令和元年</p>
        <BackBtn href={"/no160"} />
      </Content>
    </Page>
  )
}
export default Home
